export function deepSort(input: Array<any> | Object): Array<any> | Object {
  function deepCompare(a: any, b: any) {
    if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null) {
      const keysA = Object.keys(a).sort();
      const keysB = Object.keys(b).sort();

      if (keysA.length !== keysB.length) {
        return keysA.length - keysB.length;
      }

      for (let i = 0; i < keysA.length; i++) {
        const keyA = keysA[i];
        const keyB = keysB[i];

        if (keyA !== keyB) {
          return keyA < keyB ? -1 : 1;
        }

        const compareResult = deepCompare(a[keyA], b[keyB]);
        if (compareResult !== 0) {
          return compareResult;
        }
      }

      return 0;
    } else {
      if (a === b) {
        return 0;
      } else if (a === null) {
        return -1;
      } else if (b === null) {
        return 1;
      } else {
        return a < b ? -1 : 1;
      }
    }
  }

  if (Array.isArray(input)) {
    return input.sort(deepCompare);
  } else if (typeof input === 'object' && input) {
    const sortedObject = {};
    const sortedKeys = Object.keys(input).sort(deepCompare);
    sortedKeys.forEach((key) => {
      sortedObject[key] = deepSort(input[key]);
    });
    return sortedObject;
  } else {
    return input;
  }
}
